/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddDocumentDto } from '../models/work-add-document-dto';
import { WorkCreateEquipmentlogCheckinDto } from '../models/work-create-equipmentlog-checkin-dto';
import { WorkCreateEquipmentlogCheckoutDto } from '../models/work-create-equipmentlog-checkout-dto';
import { WorkCreateEquipmentlogDefektDto } from '../models/work-create-equipmentlog-defekt-dto';
import { WorkCreateEquipmentlogDto } from '../models/work-create-equipmentlog-dto';
import { WorkCreateEquipmentlogReparaturDto } from '../models/work-create-equipmentlog-reparatur-dto';
import { WorkEquipmentlog } from '../models/work-equipmentlog';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRemoveDocumentDto } from '../models/work-remove-document-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateEquipmentlogDto } from '../models/work-update-equipmentlog-dto';

@Injectable({ providedIn: 'root' })
export class WorkEquipmentlogsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `equipmentlogsV2ControllerFindAllPaginated()` */
  static readonly EquipmentlogsV2ControllerFindAllPaginatedPath = '/v2/equipmentlogs';

  /**
   * Required permissions: equipmentlogs:read, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by equipmentId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentId=$not:$like:John Doe&filter.equipmentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by equipmentlogtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentlogtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentlogtypeId=$not:$like:John Doe&filter.equipmentlogtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentlogtypeId'?: Array<string>;

    /**
     * Filter by equipmentlogtype.isStatus query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentlogtype.isStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentlogtype.isStatus=$not:$like:John Doe&filter.equipmentlogtype.isStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentlogtype.isStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmentlogtypeId</li>
     * <li>title</li>
     * <li>createdBy</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'equipmentlogtypeId:ASC' | 'equipmentlogtypeId:DESC' | 'title:ASC' | 'title:DESC' | 'createdBy:ASC' | 'createdBy:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,text,equipmentlogtype.name,createdByUser.firstName,createdByUser.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>text</li>
     * <li>equipmentlogtype.name</li>
     * <li>createdByUser.firstName</li>
     * <li>createdByUser.lastName</li>
     * <li>created</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlog>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'equipmentlogtypeId'?: (string | Array<string>);
'equipmentlogtype.isStatus'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.equipmentId', params['filter.equipmentId'], {});
      rb.query('filter.statusId', params['filter.statusId'], {});
      rb.query('filter.equipmentlogtypeId', params['filter.equipmentlogtypeId'], {});
      rb.query('filter.equipmentlogtype.isStatus', params['filter.equipmentlogtype.isStatus'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipmentlog>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'equipmentId'?: (string | Array<string>);
        'statusId'?: (string | Array<string>);
        'equipmentlogtypeId'?: (string | Array<string>);
        'equipmentlogtype.isStatus'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:read, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by equipmentId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentId=$not:$like:John Doe&filter.equipmentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentId'?: Array<string>;

    /**
     * Filter by statusId query param.
     *           <p>
     *              <b>Format: </b> filter.statusId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.statusId=$not:$like:John Doe&filter.statusId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.statusId'?: Array<string>;

    /**
     * Filter by equipmentlogtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentlogtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentlogtypeId=$not:$like:John Doe&filter.equipmentlogtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentlogtypeId'?: Array<string>;

    /**
     * Filter by equipmentlogtype.isStatus query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentlogtype.isStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentlogtype.isStatus=$not:$like:John Doe&filter.equipmentlogtype.isStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentlogtype.isStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmentlogtypeId</li>
     * <li>title</li>
     * <li>createdBy</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'equipmentlogtypeId:ASC' | 'equipmentlogtypeId:DESC' | 'title:ASC' | 'title:DESC' | 'createdBy:ASC' | 'createdBy:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,text,equipmentlogtype.name,createdByUser.firstName,createdByUser.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>text</li>
     * <li>equipmentlogtype.name</li>
     * <li>createdByUser.firstName</li>
     * <li>createdByUser.lastName</li>
     * <li>created</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlog>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'equipmentlogtypeId'?: (string | Array<string>);
'equipmentlogtype.isStatus'?: (string | Array<string>);
};
};
}> {
    return this.equipmentlogsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlog>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'equipmentlogtypeId'?: (string | Array<string>);
'equipmentlogtype.isStatus'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlog>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
'statusId'?: (string | Array<string>);
'equipmentlogtypeId'?: (string | Array<string>);
'equipmentlogtype.isStatus'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerCreate()` */
  static readonly EquipmentlogsV2ControllerCreatePath = '/v2/equipmentlogs';

  /**
   * Required permissions: equipmentlogs:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerCreate$Response(
    params: {
      body: (WorkCreateEquipmentlogDto | WorkCreateEquipmentlogCheckinDto | WorkCreateEquipmentlogCheckoutDto | WorkCreateEquipmentlogDefektDto | WorkCreateEquipmentlogReparaturDto)
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlog>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerCreate(
    params: {
      body: (WorkCreateEquipmentlogDto | WorkCreateEquipmentlogCheckinDto | WorkCreateEquipmentlogCheckoutDto | WorkCreateEquipmentlogDefektDto | WorkCreateEquipmentlogReparaturDto)
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlog> {
    return this.equipmentlogsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlog>): WorkEquipmentlog => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerFindOneById()` */
  static readonly EquipmentlogsV2ControllerFindOneByIdPath = '/v2/equipmentlogs/{id}';

  /**
   * Required permissions: equipmentlogs:read, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlog>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:read, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlog> {
    return this.equipmentlogsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlog>): WorkEquipmentlog => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerDelete()` */
  static readonly EquipmentlogsV2ControllerDeletePath = '/v2/equipmentlogs/{id}';

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.equipmentlogsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerUpdate()` */
  static readonly EquipmentlogsV2ControllerUpdatePath = '/v2/equipmentlogs/{id}';

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEquipmentlogDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlog>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEquipmentlogDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlog> {
    return this.equipmentlogsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlog>): WorkEquipmentlog => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerAddDocumentToEquipmentlog()` */
  static readonly EquipmentlogsV2ControllerAddDocumentToEquipmentlogPath = '/v2/equipmentlogs/{id}/documents';

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerAddDocumentToEquipmentlog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerAddDocumentToEquipmentlog$Response(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerAddDocumentToEquipmentlogPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerAddDocumentToEquipmentlog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerAddDocumentToEquipmentlog(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.equipmentlogsV2ControllerAddDocumentToEquipmentlog$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog()` */
  static readonly EquipmentlogsV2ControllerRemoveDocumentFromEquipmentlogPath = '/v2/equipmentlogs/{id}/documents';

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog$Response(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogsV2Service.EquipmentlogsV2ControllerRemoveDocumentFromEquipmentlogPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.equipmentlogsV2ControllerRemoveDocumentFromEquipmentlog$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
